import Reveal from './Reveal';

// Transparent section wrapper. The page-wide background lives in <PageBackground/> and
// shows through here, so sections read as one continuous page (no per-section backgrounds
// or dividers). Keeps id, vertical rhythm, scroll offset, and the yellow heading with an
// optional subtle accent number.
export default function Section({ id, heading, index, children, className = '', innerClassName = '' }) {
  return (
    <section id={id} className={`relative py-section-y lg:py-section-y-lg scroll-mt-24 ${className}`}>
      <div className={`relative z-10 mx-auto w-full max-w-7xl px-4 lg:px-12 ${innerClassName}`}>
        {heading && (
          <Reveal>
            <div className="mb-8 flex items-baseline gap-4 lg:mb-14">
              {index && (
                <span className="font-gotham text-base font-bold tabular-nums text-brand-yellow lg:text-lg">
                  {index}
                </span>
              )}
              <h2 className="font-bold font-gotham text-4xl tracking-tight text-white md:text-5xl">
                {heading}
              </h2>
            </div>
          </Reveal>
        )}
        {children}
      </div>
    </section>
  );
}
